import { Component, Inject, Input } from '@angular/core';
import { I18NEXT_SERVICE, ITranslationService } from 'angular-i18next';

import { Logger } from '@contact/upgrade';

import { IEpticaExctractEvent } from './models/eptica-extract';

interface MailContent {
  evt: IEpticaExctractEvent;
  disabled: boolean;
  open: boolean;
  conversational: boolean;
  allAttachment;
}

@Component({
  selector: 'history-mail-panel-attachment',
  templateUrl: './history-mail-panel-attachment.component.html',
  styleUrls: ['./history-mail-panel-attachment.component.scss'],
})
export class HistoryMailPanelAttachmentComponent {
  @Input() public currentEmail: MailContent;

  constructor(public readonly logger: Logger, @Inject(I18NEXT_SERVICE) public $i18next: ITranslationService) {
    this.logger = this.logger.forSource('HistoryMailPanelAttachmentComponent');
  }
}
